import { login as adminLogin } from "@/apis/v1/admin";
import { login as userLogin } from "@/apis/v1/user";
import usePersistSession from "@/hooks/usePersistSession";
import { IUserLoginResponse } from "@/modules/User/user.interface";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import * as yup from "yup";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a full email address, like jordan@acme.com.")
    .required("Enter an email address."),
  password: yup.string().required("Enter your password."),
});

export type ILogin = yup.InferType<typeof validationSchema>;
type ApiError = { errMsg?: string };

export default function useLoginForm(isAdmin: boolean) {
  const persistSession = usePersistSession();
  const userMutation = useMutation(userLogin);
  const adminMutation = useMutation(adminLogin);
  const mutation = isAdmin ? adminMutation : userMutation;
  const { handleSubmit, control } = useForm<ILogin>({
    defaultValues: { email: "", password: "" },
    resolver: yupResolver(validationSchema),
  });

  async function onValid(data: ILogin) {
    try {
      const res = (await mutation.mutateAsync(
        data
      )) as unknown as IUserLoginResponse;
      persistSession(res);
    } catch {
      // Surfaced via `errMsg` from the mutation's error state.
    }
  }

  return {
    control,
    onSubmit: handleSubmit(onValid),
    isLoading: mutation.isLoading,
    errMsg: (mutation.error as ApiError | null)?.errMsg,
    resetError: mutation.reset,
  };
}
